export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./KardexPage.vue?vue&type=template&id=cef59c8a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/KardexPage.vue?vue&type=template&id=cef59c8a&scoped=true&
// module id = 613
// module chunks = 10